<template>
    <div v-if="loading" class="preloader-spinner">
        <div class="preloader-spinner__content">
            <svg
                class="preloader-spinner__icon"
                xmlns="http://www.w3.org/2000/svg"
                width="88px"
                height="36px"
                x="0px"
                y="0px"
                viewBox="0 0 88 36"
                enable-background="new 0 0 88 36">
                <!-- Gradiet -->
                <!-- <linearGradient id="loader_gradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="100%" y2="100%">
					<stop offset="0" style="stop-color:#000" stop-opacity="0"></stop>
					<stop offset="0.5" style="stop-color:#000"></stop>
					<stop offset="1" style="stop-color:#000" stop-opacity="0"></stop>
				</linearGradient> -->

                <!-- Paths -->
                <g>
                    <path
                        d="M36.8928 11.6903C37.5889 11.2301 38.4083 11 39.3508 11C40.7474 10.9988 41.9312 11.5333 42.9023 12.6036C43.8734 13.6739 44.3589 15.2025 44.3589 17.1894C44.3583 19.8743 43.6567 21.7917 42.2541 22.9418C41.3817 23.6666 40.2808 24.0556 39.1487 24.0389C38.2207 24.0383 37.4423 23.835 36.8136 23.4291C36.4458 23.1975 36.0355 22.8013 35.5827 22.2406V28.5352H33.5198V11.3566H35.5381V12.9903C35.9045 12.4755 36.364 12.0345 36.8928 11.6903ZM38.8738 22.2296C39.8382 22.2296 40.6399 21.8249 41.279 21.0155C41.9212 20.2073 42.2422 18.9975 42.2422 17.386C42.2422 16.4029 42.1002 15.559 41.8162 14.8544C41.2894 13.4971 40.3086 12.8184 38.8738 12.8184C37.439 12.8184 36.4579 13.5346 35.9305 14.9669C35.647 15.7355 35.5053 16.7107 35.5053 17.8925C35.5053 18.8433 35.647 19.6524 35.9305 20.3198C36.467 21.593 37.4481 22.2296 38.8738 22.2296Z"></path>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.36845 11.768C4.06582 11.3078 4.88517 11.0777 5.82652 11.0777C7.22549 11.0759 8.41051 11.6104 9.3816 12.6813C10.3527 13.7522 10.8382 15.2808 10.8382 17.2671C10.8382 19.952 10.1366 21.8694 8.7334 23.0196C7.8609 23.744 6.76007 24.133 5.62805 24.1166C4.70006 24.116 3.92197 23.9128 3.2938 23.5069C2.9254 23.2746 2.51511 22.8785 2.06295 22.3183V28.6129H0V11.4343H2.01379V13.068C2.38016 12.5532 2.8397 12.1122 3.36845 11.768ZM5.34674 22.3074C6.31297 22.3068 7.11594 21.9021 7.75564 21.0933H7.75928C8.39898 20.2838 8.71762 19.0731 8.71519 17.461C8.71519 16.4779 8.57347 15.634 8.29004 14.9294C7.7608 13.5721 6.7797 12.8934 5.34674 12.8934C3.91378 12.8934 2.93298 13.6105 2.40435 15.0446C2.12091 15.8126 1.97919 16.7878 1.97919 17.9702C1.97859 18.921 2.1203 19.7301 2.40435 20.3975C2.94026 21.6707 3.92106 22.3074 5.34674 22.3074Z"></path>
                    <path
                        d="M73.3677 17.6356C72.8542 17.2985 71.8425 16.9499 70.3324 16.5897L68.9432 16.2551C68.3362 16.11 67.8771 15.9418 67.5657 15.7504C67.0268 15.4298 66.7573 15.0032 66.7573 14.4705C66.753 14.2376 66.8071 14.0073 66.9146 13.8009C67.0222 13.5945 67.1797 13.4185 67.3727 13.2893C67.783 12.9906 68.3869 12.8416 69.1844 12.8422C70.3813 12.8422 71.2219 13.1128 71.7062 13.6541C71.9967 14.0177 72.1723 14.4602 72.2106 14.9249H74.1588C74.1734 14.1264 73.9215 13.3822 73.4032 12.6923C72.5747 11.6031 71.224 11.0585 69.351 11.0585C67.9187 11.0585 66.7791 11.419 65.9325 12.1401C65.0858 12.8611 64.661 13.8058 64.6579 14.9742C64.6579 15.9634 65.1086 16.7378 66.0099 17.2973C66.5142 17.6197 67.2981 17.9117 68.3614 18.1732L70.0256 18.5873C70.9184 18.8092 71.5162 19.0045 71.8191 19.1733C72.2925 19.4494 72.5292 19.8523 72.5292 20.382C72.5292 21.0792 72.233 21.5949 71.6407 21.9289C71.0094 22.2721 70.3 22.4445 69.5823 22.429C68.2731 22.429 67.3533 22.0956 66.8228 21.4288C66.534 21.0631 66.3588 20.5337 66.2976 19.8407H64.3147C64.3693 21.0683 64.7811 22.098 65.5501 22.93C66.3191 23.7619 67.6279 24.1779 69.4766 24.1779C71.1936 24.1779 72.4715 23.7793 73.3103 22.9821C74.1491 22.1849 74.5685 21.2374 74.5685 20.1397C74.5697 19.0012 74.1694 18.1665 73.3677 17.6356Z"></path>
                    <path d="M52.5824 22.6848L54.0649 21.1959L55.5475 22.6848L54.0649 24.1736L52.5824 22.6848Z"></path>
                    <path d="M84.8192 21.1856L83.3367 22.6744L84.8192 24.1632L86.3018 22.6744L84.8192 21.1856Z"></path>
                    <path d="M19.0725 22.684L20.555 21.1952L22.0376 22.684L20.555 24.1728L19.0725 22.684Z"></path>
                </g>
            </svg>

            <span class="preloader-spinner__figure"></span>
        </div>
    </div>
</template>
<script>
export default {
    name: "LoadingBar",

    data: () => ({
        loading: true,
    }),

    methods: {
        start() {
            this.loading = true;
        },

        finish() {
            this.loading = false;
        },
    },

    mounted() {
        if (document.readyState !== "loading") {
            setTimeout(() => this.finish(), 3000);
        } else {
            window.addEventListener("DOMContentLoaded", () => {
                setTimeout(() => this.finish(), 3000);
            });
        }
    },
};
</script>

<style scoped lang="less">
.preloader-spinner {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    position: fixed;
    z-index: 999;
    background-color: @bg;
    display: flex;
    align-items: center;
    justify-content: center;

    &__content {
        position: relative;
    }

    &__icon {
        fill: #000;
        width: 176px;
        height: 72px;
        position: relative;
        display: inline-block;
    }

    &__figure {
        top: 0px;
        left: 0px;
        position: absolute;

        width: 150px;
        height: 75px;
        display: block;
        filter: blur(9px);
        background-color: @bg;
        border-radius: 100px 100px 0px 0px;
        animation: animePreloaderFigure 2.5s infinite ease-in-out;
        box-shadow: 0px 0px 10px #ffffff9c;
    }
}

@keyframes animePreloaderFigure {
    from {
        transform: translateX(-150px);
    }

    to {
        transform: translateX(130%);
    }
}
</style>
